module.exports = __webpack_public_path__ + "img/fei.5451510b.png";